export default __webpack_public_path__ + "static/media/thumb_core.be7ead47.jpg";